module.exports = __webpack_public_path__ + "static/splineshaftspic-47164f62b4558cff1a18d629a9a7d4e2.jpg";